import { Box, Skeleton } from '@factorialco/deprecated-design-system'

export const MeetingSkeleton = () => {
  const widths = [25, 50, 75, 90, 66, 33, 90, 29]
  return (
    <Box
      paddingX="s40"
      paddingTop="s24"
      style={{ width: '100%' }}
      height="full"
      alignItems="center"
      justifyContent="center"
      overflowY="hidden"
      overflowX="hidden"
    >
      <Box style={{ maxWidth: '1024px', width: '100%' }} height="full" gap="s16">
        <Box alignItems="center" justifyContent="spaceBetween" flexDirection="row">
          <Skeleton isLoading width="s120" height="s32" />
          <Skeleton isLoading width="s120" height="s12" />
        </Box>

        <Box alignItems="flexStart" justifyContent="flexStart" flexDirection="column" gap="s16">
          {widths.map((width, index) => {
            return (
              <Box style={{ width: `${width}%` }} key={index}>
                <Skeleton isLoading height="s24" />
              </Box>
            )
          })}
        </Box>
      </Box>
    </Box>
  )
}
